import { render, staticRenderFns } from "./BsiContinuousFilingTaskQueue.vue?vue&type=template&id=2598441a&scoped=true&"
import script from "./BsiContinuousFilingTaskQueue.vue?vue&type=script&lang=js&"
export * from "./BsiContinuousFilingTaskQueue.vue?vue&type=script&lang=js&"
import style0 from "./BsiContinuousFilingTaskQueue.vue?vue&type=style&index=0&id=2598441a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2598441a",
  null
  
)

export default component.exports